import { assertArray } from "core/validation";
import { get } from "lodash";
export const getFormState = ({ filmReleaseForm }) => {
    return {
        editing: filmReleaseForm.editing,
        open: filmReleaseForm.open,
        id: filmReleaseForm.id,
    };
};

export const getFilmReleaseFormCallback = ({ filmReleaseForm }) => filmReleaseForm.callback;
export const getNewFilmRelease = ({ filmReleaseForm }) => filmReleaseForm.values;

export const formatFilmReleaseToEdit = (filmRelease) => {
    return {
        title: { label: filmRelease.title, value: filmRelease.id, filmId: filmRelease.filmId },
        filmReleaseTypeID: filmRelease.filmReleaseTypeID.toString(),
        companyID: {
            value: filmRelease.companyId.id,
            label: filmRelease.companyId.title,
            contacts: filmRelease.contacts,
        },
        contacts: filmRelease.releaseContacts,
        filmRatingTypeID: filmRelease.filmRatingTypeId.id,
        
        ratingReason: filmRelease.ratingReason,
        filmReferenceId: filmRelease.filmId,
        ratingCategory: filmRelease.ratingCategory,
        ratingSubCategory: filmRelease.ratingSubCategory,
        releaseDate: filmRelease.releaseDate,
        ratingDate: filmRelease.ratingDate,
        enteredDate: filmRelease.enteredDate,
        alternativeTitles: assertArray(filmRelease.alternativeTitles)
            ? filmRelease.alternativeTitles.map((t) => ({ ...t, value: t.id, label: t.title }))
            : [],
        id: filmRelease.id,
    };
};

export function formatForNewFilm(filmRelease) {
    const label = get(filmRelease, "title.label", "");
    return {
        ...filmRelease,
        title: { label, value: null, filmId: null },
        filmReleaseTypeID: null,
        enteredDate: new Date(),
        id: null,
        releaseDate: null,
    };
}
